<template>
    <BreadCrumb PageTitle="Liste des emprunts" />
    <ListeEmprunt/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeEmprunt from "@/components/Emprunt/ListeEmprunt.vue";
   
    
    export default defineComponent({
      name: "ListeEmpruntPage",
      components: {
        BreadCrumb,
        ListeEmprunt,
      },
    });
  </script>